import column from '../../../../../common/list-table/helpers/columns';

export default (data) => {
  const { FilteredTextColumn } = column(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Contact ID', 'id').withShow(false),
        new FilteredTextColumn('First Name', 'firstName'),
        new FilteredTextColumn('Last Name', 'lastName'),
        new FilteredTextColumn('E-mail', 'emailAddress'),
      ],
    },
  ];
};
